<template>
  <main-sidebar :name="name" :title="$tc('facility') | capitalize">
    <div class="p-4">
      <div class="vx-row">
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="$t('name') | capitalize"
            v-model="facility.name"
            class="w-full"
            name="Name"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first('Name')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="($t('address') + ' 1') | capitalize"
            v-model="facility.address1"
            class="w-full"
            name="Address 2"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Address 1')">{{
            errors.first('Address 1')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="($t('address') + ' 2') | capitalize"
            v-model="facility.address2"
            class="w-full"
            name="Address 2"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Address 2')">{{
            errors.first('Address 2')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="$t('city') | capitalize"
            v-model="facility.addressCity"
            class="w-full"
            name="City"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('City')">{{
            errors.first('City')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="$t('zip') | capitalize"
            v-model="facility.addressZip"
            class="w-full"
            name="Zip"
            v-validate="'required|length:5'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Zip')">{{
            errors.first('Zip')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="$t('latitude') | capitalize"
            v-model="facility.latitude"
            class="w-full"
            name="latitude"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('latitude')">{{
            errors.first('latitude')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
          <vs-input
            :label="$t('longitude') | capitalize"
            v-model="facility.longitude"
            class="w-full"
            name="longitude"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('longitude')">{{
            errors.first('longitude')
          }}</span>
        </div>
        <div class="vx-col w-full mt-5">
            <label class="ml-2 label-custom"> {{ $t('zone') | capitalize }} </label>
            <v-select 
              v-model="facility.zone" 
              class="w-full" 
              label="zone" 
              :options="zones" 
              :reduce="item => item.id" 
              :clearable="false" />

        </div>
        <div class="vx-col w-full mt-5">
          <label class="ml-2 label-custom"> {{ $t('notes') | capitalize }} </label>
          <vs-textarea v-model="facility.notes" />
        </div>
        <!-- <div class="vx-col w-full mt-5">
        <vs-input :label="$t('tress_id') | capitalize" v-model="facility.tressId" class="w-full" />
      </div> -->
      </div>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button
        color="primary"
        type="filled"
        class="mr-6"
        @click="submit"
        :disabled="disabledSubmit"
      >
        {{ $t('save') | capitalize }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') | capitalize }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import client from '@/http/requests/client'
import vSelect from 'vue-select'
export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },

    isLoading() {
      return this.loading.submit || this.loading.zones
    },

    disabledSubmit(){
      return this.errors.any() ||
      this.facility.name === '' ||
      this.facility.address1 === '' ||
      this.facility.address2 === '' ||
      this.facility.addressCity === '' ||
      this.facility.addressZip === ''
      //this.facility.notes === ''
    }
  },
  data: () => ({
    name: 'facility',
    isEdit:false,
    loading: {
      submit: false,
      zones:false
    },
    zones:[]
  }),
  methods: {
    init(){
      this.$validator.reset()
      this.getZones()
    },
    add() {
      this.loading.submit = true
      let data = {
        ClientId:this.facility.clientId,
        Name: this.facility.name,
        Address1: this.facility.address1,
        Address2: this.facility.address2,
        AddressCity: this.facility.addressCity,
        AddressZip: this.facility.addressZip,
        notes: this.facility.notes,
        latitude: this.facility.latitude,
        longitude: this.facility.longitude,
        ZoneId: this.facility.zone === 0 ? null : this.facility.zone
        //R2SAT: this.facility.r2Sat,//solo edit
        //ZoneId: this.facility.zone//solo editt
      }
      client.addFacility(data)
        .then((res) => {
          this.loading.submit = false
          this.close()
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].facility_saved,
          });
          this.$emit('success')
        })
        .catch((res) => {
          this.loading.submit = false
          this.displayErrors(res)
        })
    },

    close() {
      this.$store.dispatch('toggleSidebar', '')
    },

    submit() {
      if (this.facility.id !== '') {
        this.update()
        return;
      }
      this.add()
    },

    update() {
      this.loading.submit = true
      let data = {
        ClientId:this.facility.clientId,
        Name: this.facility.name,
        Address1: this.facility.address1,
        Address2: this.facility.address2,
        AddressCity: this.facility.addressCity,
        AddressZip: this.facility.addressZip,
        latitude: this.facility.latitude,
        longitude: this.facility.longitude,
        notes: this.facility.notes,
        ZoneId:  this.facility.zone === 0 ? null : this.facility.zone
      }
      client.updateFacility(this.facility.id,data)
        .then((res) => {
          this.loading.submit = false
          this.close()
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].success,
            text: this.$i18n.messages[this.$i18n.locale].facility_update
          });
          this.$emit('success')
        })
        .catch((res) => {
          this.loading.submit = false
          this.displayErrors(res)
        })
    },

    getZones(){
      this.loading.zones = true
      client.getZones()
        .then( res => {
          this.loading.zones = false
          this.zones = [ { id:0, zone:'No Zone' },...res.data.zones ]
          this.facility.zone = this.facility.zone === null ? 0 : this.facility.zone 
        })
        .catch((res) => {
          this.loading.zones = false
          this.displayErrors(res)
        })
      }
    },
    mixins: [loading, validate],
    props: {
      facility: {
        default: () => ({
          clientId: '',
          id: '',
          name: '',
          address1: '',
          address2: '',
          addressCity: '',
          addressZip: '',
          latitude:'',
          longitude:'',
          zone: null,
          notes:''
        })
      }
    },
    watch: {
      isLoading(val) {
        if (val) {
          this.openLoading(`loading-${this.name}-sidebar`)
        } else {
          this.closeLoading(`loading-${this.name}-sidebar`)
        }
      },
      isSidebarActive(val) {
        if (val) {
          this.init()
        }
      },
    }
  }
</script>

<style>
</style>
